module.exports = __webpack_public_path__ + "public/img/2.7934781b.png";